module.exports = __webpack_public_path__ + "static/assets/5d5db7b4a50991d405a08854c93a0f8f.svg";